export default __webpack_public_path__ + "static/media/Integration_Filled_Active.d3a1ef04.svg";